import { ref } from 'vue'

const notification = ref({
  show: false,
  type: 'info',
  title: '',
  message: '',
  details: ''
})

export function useNotification() {
  const showNotification = ({ type = 'info', title, message, details = '' }) => {
    notification.value = {
      show: true,
      type,
      title,
      message,
      details
    }
  }

  const hideNotification = () => {
    notification.value.show = false
  }

  const showError = (title, message, details = '') => {
    showNotification({ type: 'error', title, message, details })
  }

  const showWarning = (title, message, details = '') => {
    showNotification({ type: 'warning', title, message, details })
  }

  const showSuccess = (title, message, details = '') => {
    showNotification({ type: 'success', title, message, details })
  }

  const showInfo = (title, message, details = '') => {
    showNotification({ type: 'info', title, message, details })
  }

  return {
    notification,
    showNotification,
    hideNotification,
    showError,
    showWarning,
    showSuccess,
    showInfo
  }
}